import {CommonContractorCreateUpdateApp} from "../../../../Dashboard/Contractors/Functionality/ContractorCreateUpdateFlows/CommonContractorCreateUpdateApp";
import routes from "../../../../../Routes/routes";
import HeadTittle from "../../../../../components/HeadTittle";
import ManagerFields from "../../../../Dashboard/Contractors/SubComponents/ContractorCreateUpdateFlows/ManagerFields";
import React from "react";
import {SupplierFlowEmployeeCreateApp} from "../../Funtionality/SupplierCreateUpdateFlows/SupplierFlowEmployeeCreateApp";
import {ButtonNextStep, ButtonPrevStep} from '../../../../../components/buttons/ButtonNavigation';
import CustomPhotoPicker from '../../../../../components/PhotoPicker/CustomPhotoPicker';
import {ACTION_MODEL} from '../../../../../Helpers/ActionModel';
import {FILE_TYPE} from '../../../../../Helpers/fileType';
import {SUGGESTION_MODE_OPTION} from '../../../../../components/PhotoPicker/SubComponent/Models/Models';
import SummaryEmployeeContractor
    from '../../../../Dashboard/Contractors/SubComponents/EmployeeCreateUpdateFlows/SummaryEmployeeContractor';
import StepperTabs from '../../../../../components/StepperTabs/StepperTabs';
import StepTab from '../../../../../components/StepperTabs/StepTab';
import CopySecretModal from '../../../../Dashboard/Company/Employees/Modal/CopySecretModal';
import { TABS_SUPPLIER_EMPLOYEE} from '../../../../Dashboard/Company/Employees/Model/Models';

/**
 * @Email : azapata@ibl.mx
 * @Author: Ferro Zapata Arnulfo
 * @jobTittle: Full Stack Developer
 *
 */
const SupplierFlowEmployeeCreate = () => {

    const props = CommonContractorCreateUpdateApp();

    const {
        t,
        navigate,
        permission,
        dispatch,
        isValidEmail,
        isValidPhoneNumber,
        isValidDob,
        setIsValidDob,
        isValidDocumentId,
        setIsValidDocumentId,
        isValidPassword, 
        setIsValidPassword,
        userInfoStatusList,
        supplierId,
        emptyFields,
        setEmptyFields,
        secretModal, setSecretModal,
        secretKey, setSecretKey,
        generatedPassword, setGeneratedPassword,
        passwordGenerator,
        photoPicker,
        setPhotoPicker,
        handleDateChange,
        handleEmailChange,
        handlePasswordChange,
        handlePhoneNumberChange,
        validateEmail,
        validatePhone,
        validatePassword,
    }  = props;

    const {
        user,
        setUser,
        FormHandler,
        resetForm,
        steps,
        activeStep,
        setActiveStep,
        handleStepChange,
        handleValidateSteps
    } = SupplierFlowEmployeeCreateApp({
        t,
        permission,
        dispatch,
        setEmptyFields,
        isValidEmail,
        isValidPhoneNumber,
        isValidDob,
        isValidPassword, 
        supplierId,
        photoPicker,
        setPhotoPicker,
        setSecretModal,
        setSecretKey,
        setGeneratedPassword,
        passwordGenerator,
        validateEmail,
        validatePhone,
        validatePassword
    });

    return (
        <>
            <HeadTittle
                link={routes.suppliers.employees}
                name={t("create")}
            />

            <StepperTabs
                id={null}
                steps={steps}
                activeStep={activeStep}
                isStepOptional={() => {}}
                setActiveStep={setActiveStep}
                handleStepChange={handleStepChange}
            >
                <StepTab index={TABS_SUPPLIER_EMPLOYEE.DETAILS.INDEX} activeStep={activeStep} normalHeight={true}>
                    <>
                        <ManagerFields
                            title={"user_data"}
                            user={user}
                            setUser={setUser}
                            emptyFields={emptyFields}
                            isValidDocumentId={isValidDocumentId}
                            setIsValidDocumentId={setIsValidDocumentId}
                            isValidEmail={isValidEmail}
                            isValidPhoneNumber={isValidPhoneNumber}
                            isValidDob={isValidDob}
                            setIsValidDob={setIsValidDob}
                            handleEmailChange={handleEmailChange}
                            handlePasswordChange={handlePasswordChange}
                            handlePhoneNumberChange={handlePhoneNumberChange}
                            handleDateChange={handleDateChange}
                            handleClearAll={resetForm}
                            statusList={userInfoStatusList}
                        />
                        <div className='col-sm-12 col-xxl-6 col-lg-6 offset-xxl-6 offset-lg-6'>
                            <ButtonNextStep
                                id='btn_sfec_next_user_data'
                                text='next'
                                click={() => {
                                    if(handleValidateSteps(TABS_SUPPLIER_EMPLOYEE.DETAILS.INDEX)){
                                        setActiveStep((prevStep) => prevStep + 1);
                                    }
                                }}
                            />
                        </div>
                    </>
                </StepTab>
                <StepTab index={TABS_SUPPLIER_EMPLOYEE.PHOTO.INDEX} activeStep={activeStep} normalHeight={true}>
                    <>
                        <CustomPhotoPicker
                            id='fp_sfec_create_photo_profile'
                            photoPicker={photoPicker}
                            setPhotoPicker={setPhotoPicker}
                            actionModel={ACTION_MODEL.CREATE}
                            accept={{ ...FILE_TYPE.IMAGE_FACE_VALIDATION }}
                            showBtnCamera={true}
                            validateFace={true}
                            classWith={'content-center-w-400px'}
                            showPreview={true}
                            typeSuggestions={SUGGESTION_MODE_OPTION.SELFIE} // It is required if showBtnCamera is true
                        />
                        <div className='col-12 d-flex justify-content-between mt-3'>
                            <ButtonPrevStep
                                id='btn_sfec_back_selfie'
                                text='back'
                                click={() => setActiveStep((prevStep) => prevStep - 1)}
                            />
                            <ButtonNextStep
                                id='btn_sfec_next_selfie'
                                text='next'
                                disabled={activeStep === steps.length - 1}
                                click={() => setActiveStep((prevStep) => prevStep + 1)}
                            />
                        </div>
                    </>

                </StepTab>
                <StepTab index={TABS_SUPPLIER_EMPLOYEE.SUMMARY.INDEX} activeStep={activeStep} normalHeight={true}>
                    <>
                        <SummaryEmployeeContractor
                            user={user}
                            photoPicker={photoPicker}
                        />
                        <div className='col-12 d-flex justify-content-between mt-3'>
                            <ButtonPrevStep
                                id='btn_sfec_back_summary'
                                text='back'
                                click={() => setActiveStep((prevStep) => prevStep - 1)}
                            />
                            <ButtonNextStep
                                id='btn_sfec_create'
                                text='create'
                                click={() => {
                                    FormHandler();
                                }}
                            />
                        </div>
                    </>
                </StepTab>
            </StepperTabs>

            <CopySecretModal
                show={secretModal}
                setShow={setSecretModal}
                secret={secretKey}
                setSecret={setSecretKey}
                setData={setUser}
                generatedPassword={generatedPassword}
                onHide={() => {
                    navigate(routes.suppliers.employees);
                }}
                closeText={'continue'}
            />

        </>
    );
};
export default SupplierFlowEmployeeCreate
